import {
    Button,
    Card,
    CardHeader,
    Text
} from '@fluentui/react-components';
import { Rocket24Regular } from '@fluentui/react-icons';
import * as React from 'react';
import { strings } from '../../../intl/Strings';
import { useStyles } from './WelcomeCard.styles';


export const WelcomeCard: React.FC = () => {
  const styles = useStyles();

  const handleGetStarted = () => {
  };

  return (
    <Card className={styles.card}>
      <CardHeader
        image={<Rocket24Regular />}
        header={
          <Text weight="semibold" size={500}>
            {strings.getString('welcomeCardTitle')}
          </Text>
        }
        description={
          <Text size={300}>
            {strings.getString('welcomeCardSubtitle')}
          </Text>
        }
      />
      
      <div className={styles.content}>
        <Text>
          {strings.getString('welcomeCardBody')}
        </Text>

        <Button 
          appearance="primary" 
          onClick={handleGetStarted}
          className={styles.button}
        >
          {strings.getString('welcomeCardPrimaryButton')}
        </Button>
      </div>
    </Card>
  );
};